import {
  format as fnsFormat,
  isAfter as fnsIsAfter,
  isEqual as fnsIsEqual,
  isSameDay as fnsIsSameDay,
} from "date-fns";

export enum DateFormat {
  SHORT_MONTH_AND_YEAR = "MMMM · yyyy",
  DAY_MONTH_AND_YEAR = "d MMM yyyy",
  CARD_EXPIRATION_DATE = "MM/yy",
}

const format = (date: Date, format: DateFormat) => {
  return fnsFormat(date, format);
};
const isSameDay = (date: Date, other: Date) => {
  return fnsIsSameDay(date, other);
};

const isAfter = (date: Date, other: Date) => {
  return fnsIsAfter(date, other);
};

const isEqual = (date: Date, other: Date) => {
  return fnsIsEqual(date, other);
};

export { format, isSameDay, isAfter, isEqual };
